import React from 'react';

export const NumberedPin = ({ index, className = '' }) => (
  <span
    className={`relative inline-flex h-9 w-8 items-center justify-center ${className}`}
    aria-label={`Pin ${index}`}
  >
    <svg
      viewBox="0 0 32 38"
      className="absolute inset-0 h-full w-full drop-shadow-md"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={`pin-grad-${index}`} x1="0%" y1="50%" x2="100%" y2="50%" gradientUnits="userSpaceOnUse">
          <stop offset="0%"   stopColor="#0031E6" />
          <stop offset="49.57%" stopColor="#0036FC" />
          <stop offset="100%" stopColor="#2050FF" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="32" height="32" rx="3" fill={`url(#pin-grad-${index})`} />
      <path d="M13 31 L16 37 L19 31 Z" fill={`url(#pin-grad-${index})`} />
    </svg>
    <span className="relative z-10 -mt-1.5 text-[0.95rem] font-semibold leading-none text-white">
      {index}
    </span>
  </span>
);
